// Generated by write-build-info.js. Do not commit.
export const buildInfo = {
  builtAt: "2026-11-02T16:00:11.646Z",
};
